export const getCalendarRoutePeriod = (pathname: string) => {
    const [, year, month] = pathname.split('/').filter(Boolean);

    return {year, month};
};
